import { AppState } from "../rootReducer";
import moment from "moment";

export const getTime = (state: AppState) =>
  state?.general?.time || moment().toDate();